module.exports = __webpack_public_path__ + "static/img/28.a142ba9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/28.jpg
// module id = 9aSQ
// module chunks = 1